import type { Page } from '@webapp/account/src/resources/common';

import type { LogicCondition } from '@webapp/common/entities/logic';
import type { Question } from '@webapp/common/resources/entities/question';

export interface Link {
    id: number;
    code: string;
    name: string;
}

export interface LogicLinkParamsState {
    fetch: boolean;
    fetchLogics: boolean;
    fetchPages: boolean;
    linkParamsLoaded: boolean;
    linkParamsLoading: boolean;
    items: Array<Link>;
    logics: Array<LogicCondition>;
    pages: Array<Page>;
    questions: Array<Question>;
}

export const initialState: LogicLinkParamsState = {
    fetch: false,
    fetchLogics: true,
    fetchPages: true,
    linkParamsLoaded: false,
    linkParamsLoading: false,
    items: [],
    pages: [],
    questions: [],
    logics: [],
};
